export default __webpack_public_path__ + "static/media/logo24h.0c0e9d6a.png";